export default class BaseControlService {
  BehaviorService = undefined;
  GeoLocationService = undefined;
  ActionService = undefined;
  FORMAT_FUNCTIONS = undefined;

  constructor($timeout, BehaviorService, GeoLocationService, ActionService, EventService, TemplateService, AuthService, RecordService, TypeFormatService, FORMAT_FUNCTIONS, DomService) {
    'ngInject';
    this.$timeout = $timeout;
    this.BehaviorService = BehaviorService;
    this.GeoLocationService = GeoLocationService;
    this.ActionService = ActionService;
    this.EventService = EventService;
    this.TemplateService = TemplateService;
    this.AuthService = AuthService;
    this.RecordService = RecordService;
    this.DomService = DomService;
    this.TypeFormatService = TypeFormatService;
    this.FORMAT_FUNCTIONS = FORMAT_FUNCTIONS;
  }
}